__turbopack_context__.v({
  "icon": "error-message-module-scss-module__5VMFCG__icon",
  "message": "error-message-module-scss-module__5VMFCG__message",
});
